<template>
  <div class="form_step form_step-5 form-scroll">
    <div class="wrapper">
      <div class="wrapper__step-header">
        <button type="button"
                @click.submit.prevent="goBack"
                class="popup-button btn green-btn colored-btn">
          {{__t('Повернутись назад')}}
        </button>
        <form-header :load="'75%'"></form-header>
      </div>

      <form @submit.prevent="" class="version" method="post" id="step5">
        <input type="hidden" name="landing_type" value="cash">
        <div class="input-group_title">
          <h4>{{__t('Дані про членів родини')}}</h4>
        </div>
        <div class="form-wrap fw">
          <div class="input-field">
            <label for="marital"><p>{{__t('Сімейний стан')}}</p>
              <div class="select-wrapper">
                <select name="marital" id="marital" class="required activities">
                  <option value="">{{__t('Оберіть')}}</option>
                  <option :value="status.code" v-for="status in maritalstatus">{{status.title}}</option>
                </select>
                <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
              </div>
            </label>

          </div>
          <div class="input-field">
            <label for="count_of_members_family"><p>{{__t('Скільки членів родини проживає разом з вами?')}}</p>
              <div class="select-wrapper">
                <select name="count_of_members_family" id="count_of_members_family" v-model="family_count" class="required activities">
                  <option value="">{{__t('Оберіть')}}</option>
                  <option :value="n" v-for="n in 11">{{n}}</option>
                </select>
                <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
              </div>
            </label>

          </div>
          <div class="input-field">
            <label for="count_of_workers_members_family"><p>{{__t('Скільки з них працює?')}}</p>
              <div class="select-wrapper">
                <select name="count_of_workers_members_family" id="count_of_workers_members_family" class="required activities">
                  <option value="">{{__t('Оберіть')}}</option>
                  <option :value="n" v-for="n in (family_count)">{{n}}</option>
                </select>
                <img src="/img/credit-landing-vue/select-arrow.svg" alt="Arrow down">
              </div>
            </label>

          </div>
          <div class="input-field">
            <label for="client_phone_neighbors">
              <p>{{__t('Номер телефону контактної особи')}}</p>
              <input type="tel" name="client_phone_neighbors" id="client_phone_neighbors" placeholder="Номер телефону" v-mask="'+380(##) ###-####'">
              <div v-show="typeof errorValidation.client_phone_neighbors !== 'undefined'">
                <label class="error_back" style="color: red"
                       v-for="error in errorValidation.client_phone_neighbors">{{error}}</label>
              </div>
            </label>
          </div>
        </div>

        <div class="button-group">
          <button type="button"
                  @click.submit.prevent="goBack"
                  class="popup-button btn green-btn colored-btn">
            {{__t('Повернутись назад')}}
          </button>
          <div class="button-wrapper page-bottom ">
            <button type="submit" class="btn red-btn">{{__t('Відправити заявку')}}</button>
          </div>
        </div>
      </form>
      <!-- <div class="step_greenBtn">
        <button @click.submit.prevent="goBack">
          <img src="/img/list-icon.png" alt="Arrow right">
          {{__t('Назад')}}
        </button>
      </div> -->
    </div>
  </div>
</template>

<script>
    export default {
        name: "step5",
        props: [
            'maritalstatus',
            'type_activity'
        ],
        data() {
            return {
                family_count: '',
                errorValidation : {}
            }
        },
        methods: {
            __t(phrase) {
              return window.__t(phrase);
            },
            goBack() {
                if (this.type_activity == 11) {
                    this.$emit('overStep');
                } else {
                    this.$emit('goback');
                    return false;
                }
            },
            validation: function () {
                let self = this;

                $.validator.addMethod("mobileValidate", function (value, element, arg) {
        if (value) {
          const phoneCodes = [
            '039',
            '050',
            '053',
            '067',
            '063',
            '066',
            '068',
            '073',
            '075',
            '077',
            '091',
            '092',
            '093',
            '094',
            '095',
            '096',
            '097',
            '098',
            '099',
          ];

          const phoneWithCode = value.replace(/[^0-9+]/g, '');
          let clearPhone, code;

          if (/^\+38/gi.test(phoneWithCode)) {
            code = phoneWithCode.slice(3, 6);
            clearPhone = phoneWithCode.slice(6);
          } else {
            code = phoneWithCode.slice(0, 3);
            clearPhone = phoneWithCode.slice(3);
          }

          return clearPhone.length === 7 && phoneCodes.includes(code);
        }

        return false;

      }, 'Некоректний формат номеру телефона');

                $('#step5').validate({
                    rules: {
                        marital: {
                            required: true
                        },
                      count_of_members_family: {
                            required: true
                        },
                      count_of_workers_members_family: {
                            required: true
                        },
                      client_phone_neighbors : {
                        required: true,
                        minlength: 17,
                        maxlength: 17,
                        mobileValidate: true,
                      },
                    },
                    messages: {
                        marital: {
                            required: "Заповніть поле",
                        },
                      count_of_members_family: {
                            required: "Заповніть поле",
                        },
                      count_of_workers_members_family: {
                            required: "Заповніть поле",
                        },
                      client_phone_neighbors : {
                            required: __t('Це поле обов’язкове. Заповніть його'),
                            minlength: __t('Номер телефону складається з 12 цифр'),
                            maxlength: __t('Номер телефону складається з 12 цифр'),
                            mobileValidate: __t('Некоректний формат номеру телефона'),
                        }
                    },
                    errorPlacement: function (error, element) {
                        error.insertAfter(element);
                    },
                    submitHandler: function (form) {
                        var data = $('#step5').serializeArray();
                        self.$emit('openPreloader');

                        jQuery.ajax({
                          headers: {
                            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                          },
                            data: data,
                            type: "POST",
                            url: '/cash/step5',
                            cache: false,
                            dataType: "json",
                            success: function (response) {

                                if( response.status == 'refusing'){
                                    self.$emit('error');
                                }else if(response.status == 'callback'){
                                    self.$emit('call');
                                }else{
                                    self.$emit('success');
                                }
                                self.$emit('closePreloader');

                                self.$emit('returnbegin');
                                setTimeout('location.href=location.href', 100000);
                            },
                            error: function (error) {
                                self.errorValidation = error.responseJSON;
                                self.$emit('closePreloader');
                            }
                        });
                    }
                });
            },
        },
        mounted: function () {
            this.validation();
        }
    }

</script>
